import React, { useEffect, useState } from "react";
import { TitleText } from "raffle-house-uikit";
import PartnersSlider from "../PartnersSlider/PartnersSlider";
import { getAllCharities } from "../../../services/charities";
import "./styles.css";

const CharityBlock = (props) => {
  const [charitiesList, setCharitiesList] = useState([]);

  useEffect(() => {
    getAllCharities()
      .then((result) => {
        if (Array.isArray(result)) {
          setCharitiesList(result);
        }
      })
      .catch((error) => console.error(error));
  }, []);
  return (
    <div className="charity-block">
      <TitleText isCentered as="h2" variant={"primary"} color="color-5">
        Our charity partners
      </TitleText>
      <p className="sub">Win a home and donate to one of our charity partners who receive 10% net costs.</p>
      <div className="charities-list">
        <div className="left-side">
          <a
            className="charity-logo"
            href="https://www.fundraisingregulator.org.uk/directory/raffle-house-ltd"
            rel="nofollow"
            target="_blank"
            aria-label="fundraising regulator"
          >
            <img
              src="https://www.fundraisingregulator.org.uk/fr-badge/7c26a59e-dca9-462a-8e9b-84b3c234f6f9/en/colour"
              alt="Fundraising Regulator badge with validation link"
              loading="lazy"
            />
          </a>
        </div>
        <div className="right-side">
          <PartnersSlider isDark isCharitySlider charityList={charitiesList} />
        </div>
      </div>
    </div>
  );
};

export default CharityBlock;
